









































































































import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {DeletePatientVascularAccess, GetPatientVascularAccessList} from "@/api/vascularAccess"
import AddOrEdit from './addOrEdit.vue'
import Event from './event.vue'
import OutCome from './outCome.vue'

@Component({
	components:{AddOrEdit, Event, OutCome}
})
export default class Patient extends AbpBase {
	@Prop() patient: any
	data = []
	addOrEditShow = false
	addOrEditData:any = {}
	eventShow = false
	eventData:any = {}
	outComeShow = false
	outComeData:any = {}

	created(){
		this.init()
	}

	addOne(name:any){
		this.addOrEditShow = true
		this.addOrEditData = {
			mode: 'add',
			name: name,
			patient: this.patient
		}
	}

	editOne(name:string, item:any){
		this.addOrEditShow = true
		this.addOrEditData = {
			mode: 'edit',
			name: name,
			patient: this.patient,
			item: Object.assign({}, item)
		}
	}
	outCome(item: any){
		this.outComeData = {
			item: item,
		}
		this.outComeShow = true
	}

	event(item: any){
		this.eventData = {
			patient: this.patient,
			road:item
		}
		this.eventShow = true
	}

	async deleteHistory(val:any) {
		this.$confirm('将删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			await DeletePatientVascularAccess({Id: val.id})
			this.init()
		}).catch((e:any) => {
			console.log(e)
		});
	}

	saveSuccess(){
		this.addOrEditShow = false
		this.outComeShow = false
		this.init()
	}

	private async init() {
		let res = await GetPatientVascularAccessList({PatientId:this.patient.id})
		this.data = res.objects
		console.log(this.data)
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/road/index.vue